<body>
            <div class="container-fluid" [ngClass]="{'dark-bg' : isDark }">
              <div class="row">
                <div class="col-12">                
                  <div class="invoice p-3 mb-3"> 

                    <div class="row justify-content-center">
                        <h6>Expenses Analysis Report</h6> 
                    </div>
      
                    <!-- Tabele row -->
                    <div class="row">
                    <div class="col-12">
                    <div class="card" [ngClass]="{'dark-bg' : isDark ,'dark-border-color' : isDark }">                  
                     <div class="card-body">

                       <div class="row pb-2">
                        <div class="col-3 input-group">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                  <span class="input-group-text" [ngClass]="{'dark-bg' : isDark }"><i class="fa fa-calendar-o"></i></span>
                                </div>
                                <input type="text" [ngClass]="{'dark-bg' : isDark }" [(ngModel)]="fromDate" bsDatepicker [bsConfig]="datepickerConfig" class="form-control" placeholder="From Date">
                              </div>
                          </div>
                        <div class="col-3 input-group">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                  <span class="input-group-text" [ngClass]="{'dark-bg' : isDark }"><i class="fa fa-calendar-o"></i></span>
                                </div>
                                <input type="text" [ngClass]="{'dark-bg' : isDark }" [(ngModel)]="toDate" bsDatepicker [bsConfig]="datepickerConfig" class="form-control" placeholder="To Date">
                              </div>
                        </div>
                        <div class="col-3 input-group">
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <span class="input-group-text" [ngClass]="{'dark-bg' : isDark }"><i class="fa fa-vcard"></i></span>
                            </div>
                            <select [ngClass]="{'dark-bg' : isDark }"  [(ngModel)]="expCategory"  class="form-control">        
                              <option [ngValue]="null">-Select-</option>
                              <option *ngFor="let item of EXP_TYPES" [value]="item.value">
                                {{item.value}}
                              </option>
                          </select>
                          </div>
                      </div>
                        <div class="3">
                            <button (click)="viewBtnClicked()" mat-raised-button>View</button>
                            <button (click)="clearBtnClicked()" mat-raised-button class="ml-2">Clear</button>                         
                          </div>
                        </div>

                      <div class="col-12 table-responsive" id="expReport">
                        <table class="table" [ngClass]="{'dark-bg' : isDark }">
                          <thead>
                          <tr >                          
                            <th>ExpDate</th>
                            <th>ExpNo</th>
                            <th>Supplier</th>
                            <th>ExpName</th>    
                            <th>Category</th>  
                            <th>Remarks</th>    
                            <th>CreatedBy</th>                      
                            <th class="text-right">Amount</th>                         
                          </tr>
                          </thead>
                          <tbody>
                          <tr *ngFor="let item of filteredExpenseList">    
                            <td>{{item.ExpDate | date :'y-MM-dd'}}</td>
                            <td>{{item.ExpNo}}</td>
                            <td>{{item.SupName}}</td>
                            <td>{{item.ExpName}}</td>  
                            <td>{{item.ExpCategory}}</td>   
                            <td>{{item.Remarks}}</td>  
                            <td>{{item.CreatedBy}}</td>  
                            <td class="text-right">{{item.Amount |  number:'1.2-2'}}</td>                                                                                
                          </tr>  
                          <tr class="table-active">
                            <td colspan="7" class="text-right text-bold">Total :</td>
                            <td class="text-right text-bold">{{getTotal() | number:'1.2-2'}}</td>
                          </tr>                                              
                          </tbody>
                        </table>
                      </div>
                      <!-- /.col -->
                     </div>
                    </div>
                    </div>
                    </div>
                    <!-- /.row -->
      
      
                    <!-- this row will not appear when printing -->
                    <div class="row no-print">
                      <div class="col-12">
                        <button [ngClass]="{'dark-bg' : isDark }" type="button" (click)="savePDF('print')"  class="btn btn-default float-right"><i class="fas fa-print"></i> Print</button>      
                        <button [ngClass]="{'dark-bg' : isDark }" type="button" (click)="exportexcel()"  class="btn btn-default float-right"><i class="fa fa-file-excel-o" style="color:green"></i> Excel</button>      
                         <button [ngClass]="{'dark-bg' : isDark }" type="button" (click)="savePDF('open')"  class="btn btn-default float-right"><i class="fa fa-file-pdf-o" style="color:red"></i> PDF</button>                                                                                                                                                            
                      </div>
                    </div>


                  </div><!-- /.invoice -->                 
                </div><!-- /.col -->
              </div><!-- /.row -->
            </div><!-- /.container-fluid -->        
 </body>






